import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';

export function Layout() {
    const location = useLocation();
    const isDashboard = location.pathname.startsWith('/dashboard');
    const isCandidateDashboard = location.pathname.startsWith('/candidate/dashboard');
    const isRoom = location.pathname.startsWith('/room/');

    return (
        <div className="min-h-screen bg-background text-foreground flex flex-col selection:bg-primary/30">
            {!isRoom && <Navbar />}
            {/* justify content center */}
            <main className={`flex-1 flex flex-col ${!isRoom ? 'pt-16' : ''} justify-center`}>
                <Outlet />
            </main>
            {!isDashboard && !isRoom && !isCandidateDashboard && <Footer />}
        </div>
    );
}
